

export const DATA_TABLE_COLUMN_DATA_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  PERCENTAGE: 'percentage'
};